import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'
import CSelect from '@/components/CForm/CSelect'
import { libraryManage } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {message, Modal} from 'antd'
@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.onChange = this.onChange.bind(this)
    this.download = this.download.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    loading: true,
    ownerid: '',
    ownerlist:[],
    level:[
      {name:'全部',id:-1},
      {name:'一级',id:1410},
      {name:'二级',id:1411},
      {name:'三级',id:1412},
    ],
    levelid:-1,
  };


  // 获取用户列表数据
  getListData(){
    let getData = {
      provinceid: this.state.ownerid,
      levelid:this.state.levelid
    };
    this.setState({
      loading: true
    });
    libraryManage(getData).then(res=>{
      let data =JSON.parse(JSON.stringify(res.records[0].datalist))
      let total = 1;
      this.setState({
        dataSource: data,
        page: {...this.state.page, total},
        loading: false,
        ownerlist:res.records[0].provincelist?res.records[0].provincelist:[]
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  onChange(data){
    this.setState({
      ownerid:data
    },()=>{
      this.getListData()
    })
  }

  download(){
    let getData = {
      provinceid: this.state.ownerid,
      levelid:this.state.levelid == -1 ? '' : this.state.levelid,
      export:1
    };
    this.setState({
      loading: true
    });
    libraryManage(getData).then(res=>{
      this.setState({
        loading: false
      });
      window.location.href = res.records[0].download
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  changProvinceHandler(value,type) {
    this.setState({
      [type]: value
    }, () => {
      this.getListData()
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('libraryuser', JSON.stringify(data))
    this.props.history.push({
      pathname: '/libraryuser/addcountryCentral',
      search: `?type=edit&id=${data.id}`
    })
  }
  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='flex filter-left'>
              {this.state.ownerlist.length>0&&<CSelect
                  value={this.state.ownerid}
                  options={this.state.ownerlist}
                  placeholder='请选择省份'
                  onChange={this.onChange}
              />}
              <CSelect value={this.state.levelid} options={this.state.level} placeholder='请选择申报等级'
                       onChange={(value) => this.changProvinceHandler(value, 'levelid')}/>
              <CButton size='medium' block type='primary' onClick={this.download}>下载</CButton>
            </div>
          </div>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>编辑</CButton>
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
